export const TRANSLATIONS = "TRANSLATIONS"

export const TRANSLATIONS_FETCH_TRANSLATE_LIST =
  "TRANSLATIONS_FETCH_TRANSLATE_LIST"
